import { getIdTokenResult } from 'firebase/auth'
import { AppRoutes } from '~/constants/routes'

export default defineNuxtRouteMiddleware(async (to) => {
  const { claims, setClaims } = useUser()
  const user = await getCurrentUser()

  // TODO: Check if user is suspended
  if (user) {
    // TODO: Check if it is the right place to set claims
    if (!claims.value) {
      const idTokenResult = await getIdTokenResult(user)
      setClaims(idTokenResult.claims)
    }
  }
  else {
    return navigateTo({
      path: AppRoutes.Auth.Login,
      ...(to.fullPath !== '/' && {
        query: {
          redirect: to.fullPath,
        },
      }),
    })
  }
})
